import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-18611d10")

_pushScopeId("data-v-18611d10")
const _hoisted_1 = { class: "css-property border-t py-16" }
const _hoisted_2 = { class: "flex flex-wrap -mx-4" }
const _hoisted_3 = { class: "w-full lg:w-2/5 px-4" }
const _hoisted_4 = { class: "font-bold mb-4 leading-6" }
const _hoisted_5 = { class: "text-gray-400 mr-1" }
const _hoisted_6 = { class: "text-gray-400" }
const _hoisted_7 = /*#__PURE__*/_createVNode("span", { class: "inline-block align-middle mr-1" }, "Demo", -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "12",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  class: "feather feather-external-link inline-block align-middle"
}, [
  /*#__PURE__*/_createVNode("path", { d: "M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" }),
  /*#__PURE__*/_createVNode("polyline", { points: "15 3 21 3 21 9" }),
  /*#__PURE__*/_createVNode("line", {
    x1: "10",
    y1: "14",
    x2: "21",
    y2: "3"
  })
], -1)
const _hoisted_9 = { class: "w-full lg:w-3/5 px-4" }
const _hoisted_10 = { class: "py-4 lg:py-0" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("h3", _hoisted_4, [
          _createVNode("span", _hoisted_5, _toDisplayString(_ctx.demoIndex + 1) + ".", 1),
          _createVNode("a", {
            href: _ctx.data.mdn_url,
            target: "_blank",
            rel: "noopener noreferrer"
          }, _toDisplayString(_ctx.name), 9, ["href"])
        ]),
        _createVNode("div", _hoisted_6, [
          _createVNode("button", {
            class: ["text-xs font-bold tracking-wider uppercase transition duration-200 ease border rounded px-2 py-1  hover:bg-gray-800 hover:text-white mr-1", _ctx.isExpand ? 'text-white bg-gray-800' : ''],
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleData && _ctx.toggleData(...args)))
          }, " Data ", 2),
          (_ctx.componentNames.includes(_ctx.pascalCase(_ctx.name)))
            ? (_openBlock(), _createBlock("a", {
                key: 0,
                class: "text-xs font-bold tracking-wider uppercase transition duration-200 ease border rounded px-2 py-1  hover:bg-gray-800 hover:text-white text-gray-400 no-underline",
                href: 
              'https://github.com/simboonlong/css-animatable/blob/master/src/components/CssProperty/' +
                _ctx.pascalCase(_ctx.name) +
                '.vue'
            ,
                target: "_blank",
                rel: "noopener noreferrer"
              }, [
                _hoisted_7,
                _hoisted_8
              ], 8, ["href"]))
            : _createCommentVNode("", true)
        ]),
        _createVNode("pre", {
          class: ["z-10 text-xs bg-gray-800 text-white p-4 rounded my-1 absolute shadow-lg max-w-lg", _ctx.isExpand ? '' : 'hidden']
        }, _toDisplayString(_ctx.data), 3)
      ]),
      _createVNode("div", _hoisted_9, [
        _createVNode("div", _hoisted_10, [
          (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.name)))
        ])
      ])
    ])
  ]))
})